module.exports = __webpack_public_path__ + "img/wordwall.61990582.svg";